export const API_BASE_URL = process.env.REACT_APP_API_URL

const createApi = (module, action, method = "post") => ({
	method,
	url: `api/${module}/${action}`,
})

// Auth
export const ApiLogin = createApi('Auth', 'Login')
export const ApiCheckAuth = createApi('Auth', 'CheckAuth')
export const ApiRegister = createApi('Auth', 'Register')

// User
export const ApiUpdateUser = createApi('User', 'Update')
export const ApiDeleteUser = createApi('User', 'Delete')
export const ApiGetUser = createApi('User', 'GetById')
export const ApiGetUserList = createApi('User', 'GetList')
export const ApiCheckIsAdmin = createApi('User', 'CheckIsAdmin')


// Tenant
export const ApiInsertTenant = createApi('Tenant', 'Create')
export const ApiUpdateTenant = createApi('Tenant', 'Update')
export const ApiDeleteTenant = createApi('Tenant', 'Delete')
export const ApiGetTenant = createApi('Tenant', 'GetById')
export const ApiGetTenantList = createApi('Tenant', 'GetList')

// Booking
export const ApiInsertBooking = createApi('Booking', 'Create')
export const ApiUpdateBooking = createApi('Booking', 'Update')
export const ApiDeleteBooking = createApi('Booking', 'Delete')
export const ApiGetBooking = createApi('Booking', 'GetById')
export const ApiGetBookingList = createApi('Booking', 'GetList')
export const ApiGetBookingTenantList = createApi('Booking', 'GetTenantList')
export const ApiGetAvailableRoomList = createApi('Booking', 'GetAvailableRoom')
export const ApiCompleteBooking = createApi('Booking', 'CompleteBooking')
export const ApiReactiveBooking = createApi('Booking', 'ReactiveBooking')
export const ApiCheckInBooking = createApi('Booking', 'CheckIn')

// Room Type
export const ApiInsertRoomType = createApi('RoomType', 'Create')
export const ApiUpdateRoomType = createApi('RoomType', 'Update')
export const ApiDeleteRoomType = createApi('RoomType', 'Delete')
export const ApiGetRoomType = createApi('RoomType', 'GetById')
export const ApiGetRoomTypeList = createApi('RoomType', 'GetList')

// Room
export const ApiInsertRoom = createApi('Room', 'Create')
export const ApiUpdateRoom = createApi('Room', 'Update')
export const ApiDeleteRoom = createApi('Room', 'Delete')
export const ApiGetRoom = createApi('Room', 'GetById')
export const ApiGetRoomList = createApi('Room', 'GetList')

// Payment
export const ApiInsertPayment = createApi('Payment', 'Create')
export const ApiUpdatePayment = createApi('Payment', 'Update')
export const ApiDeletePayment = createApi('Payment', 'Delete')
export const ApiGetPayment = createApi('Payment', 'GetById')
export const ApiGetPaymentList = createApi('Payment', 'GetList')
export const ApiGetPaymentByBookingId = createApi('Payment', 'GetPaymentByBookingId')

// Expense
export const ApiInsertExpense = createApi('Expense', 'Create')
export const ApiUpdateExpense = createApi('Expense', 'Update')
export const ApiDeleteExpense = createApi('Expense', 'Delete')
export const ApiGetExpense = createApi('Expense', 'GetById')
export const ApiGetExpenseList = createApi('Expense', 'GetList')

// DEPOSIT RETURN
export const ApiInsertDepositReturn = createApi('DepositReturned', 'Create')
export const ApiGetDepositList = createApi('DepositReturned', 'GetList')
export const ApiDeleteDeposit = createApi('DepositReturned', 'Delete')


// DASHBOARD
export const ApiGetDashboardInfo = createApi('Dashboard', 'GetDashboardInfo')

// TENANT REGISTRATION
export const ApiCreateTenantAccessKey = createApi('TenantAccessKey', 'Create')
export const ApiDeleteTenantAccessKey = createApi('TenantAccessKey', 'Delete')
export const ApiCheckTenantAccessKey = createApi('TenantAccessKey', 'CheckTenantAccessKey')

// REPORT
export const ApiGetDetailPaymentReport = createApi('Reports', 'GetDetailPaymentReport')
export const ApiGetPaymentInvoice = createApi('Reports', 'GetPaymentInvoice')




